var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('datetime',{staticClass:"datepicker",attrs:{"phrases":{ ok: 'Choisir', cancel: 'Annuler' }},model:{value:(_vm.context.model),callback:function ($$v) {_vm.$set(_vm.context, "model", $$v)},expression:"context.model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }